import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { books } from '../data/siteData';

const { FiArrowUpRight, FiShoppingBag } = FiIcons;

const AMAZON_BOOK_URL = 'https://www.amazon.com/dp/B0CL83B5WR';

export default function BooksSection() {
  return (
    <section className="section books-section" id="books">
      <div className="section-heading">
        <p className="eyebrow">Enter the story</p>
        <h2>Books where <em>magic has a price</em></h2>
        <p>Cursed pocket junk, hidden contracts, and a small Texas town with nine days left to save itself.</p>
      </div>
      <div className="books-grid">
        {books.map((book, index) => (
          <motion.article
            className="book-card"
            key={book.title}
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.7, delay: index * 0.15 }}
          >
            <a
              className="book-cover-link"
              href={index === 0 ? AMAZON_BOOK_URL : '#world'}
              target={index === 0 ? '_blank' : undefined}
              rel={index === 0 ? 'noreferrer' : undefined}
              aria-label={index === 0 ? `Purchase ${book.title} on Amazon` : `Explore the world of ${book.title}`}
            >
              <div className="book-cover" style={{ '--accent': book.color }}>
                <img src={book.image} alt={`Atmospheric artwork for ${book.title}`} />
                <div className="book-cover-copy">
                </div>
              </div>
            </a>
            <div className="book-info">
              <span className="book-number">{book.number}</span>
              <p className="book-series">{book.series}</p>
              <h3>{book.title}</h3>
              <blockquote>“{book.quote}”</blockquote>
              <p>{book.description}</p>
              <div className="tag-row">
                {book.tags.map((tag) => <span key={tag}>{tag}</span>)}
              </div>
              <a
                href={index === 0 ? AMAZON_BOOK_URL : '#world'}
                target={index === 0 ? '_blank' : undefined}
                rel={index === 0 ? 'noreferrer' : undefined}
              >
                {index === 0 ? 'Buy on Amazon' : 'Explore this world'}
                <SafeIcon icon={index === 0 ? FiShoppingBag : FiArrowUpRight} />
              </a>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
